<template>
  <div class="content">
    <HeaderProductResale
        title="Transações - Histórico"
        text="Registros de todas as transações"
        actionTitle=""
        :haveAction="false"
        :haveBack="true"
    >
    </HeaderProductResale>

    <v-container style="max-width: unset">
      <v-card elevation="0" class="pa-3">
        <v-row>
          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label>Data de início</label>
            <v-text-field
                v-model="filter.startDate"
                outlined
                dense
                height="41"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label>Data de término</label>
            <v-text-field
                v-model="filter.endDate"
                outlined
                dense
                height="41"
                type="date"
            ></v-text-field>
          </v-col>

          <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label>Revenda</label>
            <v-autocomplete
                v-model="filter.resaleIds"
                clearable
                :items="resales"
                item-text="name"
                item-value="id"
                append-icon="mdi-chevron-down"
                outlined
                label="Revenda"
                menu-props="auto"
                multiple
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row justify="end">
          <v-col justify="end" cols="12" xs="12" sm="12" md="6" lg="6" xl="6"
                 class="px-2 d-flex justify-end"
                 style="margin-top: -20px; "
          >
            <v-btn
                outlined
                height="41"
                style="border-radius: 8px!important;"
                class="mr-3"
                large
                @click="list()"
            >
              Buscar
            </v-btn>

            <v-btn
                outlined
                style="border-radius: 8px!important;"
                large
                height="41"
                dense
                @click="reset()"
            >
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-data-table
          :items="items"
          :loading="loading"
          :headers="headers"
          class="content-table"
          style="cursor: pointer"
          hide-default-footer
          loading-text="Buscando..."
          no-data-text="Sem registros"
      >
        <template v-slot:[`header.download`]="{ header }">
          <v-btn
              outlined
              tile
              icon
              v-on="header"
              width="35"
              height="30"
              class="quinary-button"
              style="border-radius: 5px"
              @click="excel"
          >
            <v-icon>mdi-download-outline</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.order`]="{ item }">
          {{
            (item.order.totalPrice + item.order.fretePrice + item.order.installmentsInterest).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>

        <template v-slot:[`item.orderStatus`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  style="border-radius: 12px"
                  :class="
                      item.order.orderStatus === 0
                        ? 'novo'
                        : item.order.orderStatus === 1
                        ? 'aguardando'
                        : item.order.orderStatus === 3 ||
                          item.order.orderStatus === 6 ||
                          item.order.orderStatus === 10
                        ? 'enviado'
                        : item.order.orderStatus === 4 || item.orderStatus === 9
                        ? 'enviado'
                        : item.order.orderStatus === 7 ||
                          item.order.orderStatus === 5 ||
                          item.order.orderStatus === 2 ||
                          item.order.orderStatus === 11
                        ? 'devolvido'
                        : 'entregue'
                    "
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon style="font-size: 15px"
                >{{
                    status1.find((x) => x.value === item.order.orderStatus).label
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
                status1.find((x) => x.value === item.order.orderStatus).label
              }}</span>
          </v-tooltip>
        </template>

        <template
            v-slot:[`item.actions`]="{ item }"
            cols="12"
            md="6"
            xs="12"
            sm="12"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  outlined
                  fab
                  tile
                  :disabled="item.done"
                  small
                  class="edit-button"
                  @click="orderDetail(item, $event)"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon color="#e30011" dark>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
            <span>Ver pedido</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.created_at`]="{ item }">
              <span :class="item.order.orderStatus == 0 ? 'novo-bold' : 'normal'">
                {{ formatDate(item.order.created_at) }}
              </span>
        </template>
        <template v-slot:[`item.frete`]="{ item }">
          {{ item.frete ? 'Sim' : 'Não' }}
        </template>

        <template v-slot:[`item.commission`]="{ item }">
          {{
            (item.commission).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>
        <template v-slot:[`item.discount`]="{ item }">
          {{
            (item.order.discount).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>

        <template v-slot:[`item.totalVendedor`]="{ item }">
          {{
            (((item.order.totalPrice + item.order.fretePrice + item.order.installmentsInterest) - (item.commission  + item.order.fees + item.order.items.filter(x => x.refundDate).reduce((acumulador, produto) => acumulador + (produto.price * produto.qty), 0)))).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}}
        </template>
        <template v-slot:[`item.refund`]="{ item }">
          {{
            (item.order.items.filter(x => x.refundDate).reduce((acumulador, produto) => acumulador + (produto.price * produto.qty), 0)).toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}}
        </template>

        <template v-slot:[`item.fees`]="{ item }">
          {{
            item.order.fees.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })
          }}
        </template>
        <template v-slot:footer class="ma-0 pa-0">
          <section class="ma-0 pa-0">
            <Pagination
                v-if="totalItems > pageSize"
                :currentPage="currentPage"
                :totalItems="totalItems"
                :page="page"
                :pageSize="pageSize"
                :totalPages="pageCount"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import ApiService from "../../../services/ApiService";
import Vue from "vue";
import Utils from "../../../Utils/FormatDate";
import Pagination from "@/views/pages/components/Pagination.vue";
import HeaderProductResale from "./components/HeaderProductResale.vue";

export default {
  name: "Shipments",
  components: {
    HeaderProductResale,
    Pagination,
  },
  props: {},

  async created() {
    await this.list();
    await this.searchResales();
  },

  data() {
    return {
      pageCount: 1,
      resaleproductsku: null,
      items: [],
      resales: [],
      products: [],
      resaleSelected: [],
      productsSelected: [],
      loading: false,
      dialogSendForResale: false,
      dialogSendForProduct: false,
      searchCategoryInput: '',
      dialog: false,
      apiService: new ApiService(),
      status1: [
        {label: "Aguardando", value: 1},
        {label: "Reprovado", value: 2},
        {label: "Aprovado", value: 3},
        {label: "Separando", value: 6},
        {label: "Etiqueta", value: 10},
        {label: "Enviado", value: 4},
        {label: "Entregue", value: 8},
        {label: "Cancelado", value: 7},
        {label: "Retirar", value: 9},
        {label: "Devolvido", value: 5},
        {label: "Reprovado", value: 2},
        {label: "Entregue", value: 8},
        {label: "Devolvido", value: 5},
        {label: "Cancelado", value: 7},
        {label: "Cancelado parcialmente", value: 11},
      ],
      headers: [
        {
          align: "center",
          sortable: false,
          value: "download",
        },
        {
          text: "Pedido Id",
          align: "center",
          sortable: false,
          value: "order.id",
        },
        {
          text: "Remessa Id",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Total",
          align: "center",
          sortable: false,
          value: "order",
        },
        {
          text: "Cobrado de",
          align: "center",
          sortable: false,
          value: "user.name",
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "orderStatus",
        },
        {
          text: "Data do Pedido",
          align: "center",
          sortable: false,
          value: "created_at",
        },
        {
          text: "Nome do Vendedor",
          align: "center",
          sortable: false,
          value: "order.resale.nameFantasy",
        },
        {
          text: "Frete Grátis",
          align: "center",
          sortable: false,
          value: "frete",
        },
        {
          text: "Comissão",
          align: "center",
          sortable: false,
          value: "commission",
        },
        {
          text: "Desconto",
          align: "center",
          sortable: false,
          value: "discount",
        },
        {
          text: "Taxas",
          align: "center",
          sortable: false,
          value: "fees",
        },
        {
          text: "Reembolso parcial",
          align: "center",
          sortable: false,
          value: "refund",
        },
        {
          text: "Total Vendedor",
          align: "center",
          sortable: false,
          value: "totalVendedor",
        },

        {
          text: "Ações",
          align: "center",
          value: "actions",
          sortable: false,
        },
      ],
      pageSize: 10,
      currentPage: 10,
      totalItems: 10,
      page: 1,
      resale: 1,
      product: 2,
      filter: {
        startDate: null,
        endDate: null,
        city: null,
        state: null,
        country: null,
        resaleIds: [],
        page: 1,
      },
      minimumStockcs: {
        resaleIds: [],
        productSkuIds: [],
        notifyBy: 1
      },
    };
  },
  computed: {},
  methods: {
    formatDate(date) {
      return Utils.moment(date);
    },
    searchResales() {
      this.apiService.get("resale/list").then((response) => {
        this.resales = response;
      });
    },
    async reset() {
      this.filter = {
        startDate: null,
        endDate: null,
        city: null,
        state: null,
        country: null,
        resaleIds: [],
        page: 1,
      }
      await this.list()
    },
    async list() {
      try {
        this.loading = true;
        console.log(this.filter)
        this.apiService
            .post("dashboard/shipments", this.filter)
            .then((response) => {
              this.items = response.content.data;
              this.pageCount = response.content.pager.totalPages;
              this.totalItems = response.content.pager.totalItems;
              this.currentPage = response.content.pager.currentPage;

              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
      } catch (e) {
      }
    },

    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },

    excel() {
      this.loading = true;

      this.apiService
          .post(
              "dashexport/shipments",
              {...this.filter, page: this.page},
              false,
              false,
              true
          )
          .then((response) => {
            const excel =
                "data:application/octet-stream;base64," + response.content;
            const link = document.createElement("a");
            link.href = excel;
            link.setAttribute("download", `remessas.xlsx`);
            document.body.appendChild(link);
            link.click();
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
    },

    async orderDetail(item) {
      await this.$router.push({
        path: `/order-detail?id=` + item.order.id,
        params: item,
      });
    },
  },

  watch: {
  },
};
</script>

<style>
.aguardando {
  width: max-content !important;
  height: 30px !important;
  color: orange !important;
  border: 1px solid orange !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.aprovado {
  height: 30px !important;
  color: #fee853 !important;
  border: 1px solid #fee853;
  box-sizing: border-box !important;
  border-radius: 7px !important;
  font-style: normal !important;
  font-weight: 300 !important;
  font-size: 3px !important;
}

.entregue {
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
}

.enviado {
  height: 30px !important;
  color: #8dc63f !important;
  border: 1px solid #8dc63f !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.devolvido {
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.cancelado {
  height: 30px !important;
  color: #e30011 !important;
  border: 1px solid #e30011 !important;
  box-sizing: border-box !important;
  border-radius: 7px !important;
}

.edit-button {
  margin-top: -5px !important;
  border: 1px solid #e30011 !important;
  border-radius: 4px;
  width: 35px !important;
  height: 30px !important;
}
</style>
